module.exports = "/_next/static/images/photoJuanDelCalvo-cbaed9ae3072488abc38cbd14a44b212.webp";